import React from "react";
import type { CategoryStyle } from "./theme";

type Props = {
  categories: CategoryStyle[];
  active: ReadonlySet<string>;
  onToggle: (key: string) => void;
};

export function CategoryChips({ categories, active, onToggle }: Props) {
  if (categories.length < 2) return null;
  return (
    <div className="bwo-chips">
      {categories.map((cat) => (
        <button
          key={cat.key}
          type="button"
          className={`bwo-chip-filter${active.has(cat.key) ? "" : " bwo-chip-filter--off"}`}
          aria-pressed={active.has(cat.key)}
          onClick={() => onToggle(cat.key)}
        >
          <span className="bwo-dot" style={{ background: cat.dot }} />
          {cat.label}
        </button>
      ))}
    </div>
  );
}
